const parseNumber = (value, fallback) => {
  const num = Number(value);
  return Number.isFinite(num) ? num : fallback;
};

const monthlyProPrice = parseNumber(process.env.REACT_APP_PRO_MONTHLY_PRICE, 9.99);
const configuredAnnualDiscount = process.env.REACT_APP_PRO_ANNUAL_DISCOUNT;
// Use Stripe's billed total; the rounded monthly equivalent is only for display.
const annualProTotalPrice = parseNumber(
  process.env.REACT_APP_PRO_ANNUAL_TOTAL_PRICE,
  71.92
);
const annualProMonthlyPrice = Number((annualProTotalPrice / 12).toFixed(2));
const annualDiscount = parseNumber(
  configuredAnnualDiscount,
  monthlyProPrice > 0 ? Math.max(0, 1 - annualProTotalPrice / (monthlyProPrice * 12)) : 0
);

export const BILLING_INTERVALS = {
  MONTHLY: "monthly",
  ANNUAL: "annual",
};

export const pricing = {
  monthlyProPrice,
  annualProMonthlyPrice,
  annualProTotalPrice,
  annualDiscount,
  annualDiscountPercent: Math.round(annualDiscount * 100),
  currency: process.env.REACT_APP_PRO_PRICE_CURRENCY || "USD",
};

export const formatPrice = (value, currency = pricing.currency) => {
  const num = Number(value);
  const display = Number.isFinite(num)
    ? num.toFixed(2).replace(/\.00$/, "")
    : value;
  return currency === "USD" ? `$${display}` : `${display} ${currency}`;
};

export const getBillingPriceSummary = (billingInterval) => {
  const isAnnual = billingInterval === BILLING_INTERVALS.ANNUAL;
  return {
    billingInterval: isAnnual ? BILLING_INTERVALS.ANNUAL : BILLING_INTERVALS.MONTHLY,
    monthlyDisplayPrice: formatPrice(
      isAnnual ? pricing.annualProMonthlyPrice : pricing.monthlyProPrice
    ),
    monthlyPrice: formatPrice(pricing.monthlyProPrice),
    annualMonthlyPrice: formatPrice(pricing.annualProMonthlyPrice),
    annualTotalPrice: formatPrice(pricing.annualProTotalPrice),
    savePercent: pricing.annualDiscountPercent,
  };
};
